/** A product's header on the standing-policy sheet (DESIGN §4.2): its name on the left in bold, its balance and yield on the right, and "Book details", which opens the book table in a Drawer (the page, the draft and the open row stay where they were). */
import { useState } from "react";
import { Drawer } from "../theme/Drawer";
import type { ProductStrip } from "./deskSheet";

export function ProductHeader({ title, strip, details, productId }: { readonly title: string; readonly strip: ProductStrip | null; readonly details: ProductStrip | null; readonly productId: string }) {
  const [open, setOpen] = useState(false);
  const facts = strip?.facts.slice(0, 2) ?? [];
  return (
    <div className="gx-decide-pol-ph" data-testid={`decide.product.${productId}`}>
      <b className="gx-decide-pol-pt">{title}</b>
      {facts.length === 0 ? null : <span className="gx-decide-pol-facts gx-num" data-testid={`decide.product.${productId}.facts`}>{facts.map((f) => <span key={f.label}>{f.label} <b>{f.value}</b></span>)}</span>}
      {details === null ? null : <button type="button" className="gx-plan-inline" data-testid={`decide.product.${productId}.book`} onClick={() => setOpen(true)}>Book details</button>}
      {!open || details === null ? null : (
        <Drawer title={title} context={<span className="gx-small gx-faint">Book details, as the Bank tab prints them</span>} onClose={() => setOpen(false)}>
          <table className="gx-table gx-num" data-testid={`decide.product.${productId}.table`}>
            <tbody>{details.facts.map((f) => <tr key={f.label}><th scope="row">{f.label}</th><td>{f.value}</td></tr>)}</tbody>
          </table>
        </Drawer>
      )}
    </div>
  );
}
